import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Flags } from 'src/app/components/shared/types/flags.type';
import { ValidatorService } from '../../validator/validator.service';

@Component({
  selector: 'app-mu-modal-schedule',
  templateUrl: './mu-modal-schedule.component.html',
  styleUrls: ['./mu-modal-schedule.component.sass'],
})
export class MuModalScheduleComponent<FlagType> implements OnInit {
  @Input() set minDate(newDate: Date) {
    this.baseMinDate = newDate;
    this.addMinutesArray();
  }
  @Input() startDateTime: Date;
  @Input() formData: UntypedFormGroup;
  @Input() showFlag: FlagType;
  @Input() actionFlag: FlagType;
  @Input() loaderFlag: FlagType;
  @Input() flagList: Flags<FlagType>;
  @Input() selectedDate: boolean;
  baseMinDate: Date;
  timeVar = new Date();
  timeVar2 = new Date();
  arrayMinute = [];
  wasChangedDate: boolean;

  constructor(public changeDetectorRef: ChangeDetectorRef, public validatorService: ValidatorService) {
    /** */
  }

  ngOnInit(): void {
    this.addMinutesArray();
  }

  /**
   * generate array hour with each 15min
   * return void
   */
  addMinutesArray(): void {
    this.timeVar = new Date(this.startDateTime);
    this.timeVar2 = new Date(this.timeVar);

    const minutes = (Math.ceil(this.timeVar.getMinutes() / 15) * 15) % 60;
    if (minutes === 0) {
      this.timeVar.setHours(this.timeVar.getHours() + 1);
    }

    this.timeVar.setMinutes(minutes);
    this.timeVar2.setMinutes(this.timeVar.getMinutes());

    const nextDate = new Date(this.timeVar);
    nextDate.setDate(this.timeVar.getDate() + 1);
    nextDate.setHours(0, 0, 0, 0);

    let diff = (this.timeVar.getTime() - nextDate.getTime()) / 1000;
    diff /= 60 * 60;

    const totalQuarterMin = Math.abs(Math.round(diff)) * 5;

    let time3 = new Date(this.timeVar2);
    this.arrayMinute = [];
    for (let i = 0; i < totalQuarterMin; i++) {
      const time4 = new Date(time3);
      time4.setMinutes(time3.getMinutes() + 15);

      if (time4 < nextDate) {
        this.arrayMinute[i] = {
          label:
            time3.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) +
            ' ' +
            time4.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }),
          value: time4,
        };
      }
      time3 = time4;
    }
  }

  /**
   * update startDateTime with select new day in the calendar
   * return void
   */
  onChangeTime(): void {
    this.formData.get('startDateTime').setValue(this.startDateTime);
  }

  /**
   * Update array hour with each 15min
   * return void
   */
  onSelectDateTime(): void {
    this.arrayMinute = null;
    this.addMinutesArray();
    this.formData.get('startDateTime').setValue(this.startDateTime);
  }

  /**
   * Update startDateTime with new date selected
   * return void
   */
  onSelectDate(event): void {
    this.startDateTime = event.value;
    this.formData.get('startDateTime').setValue(this.startDateTime);
  }

  /**
   * check if emit updated radio button
   * @return void
   */
  canceled(): void {
    if (!this.selectedDate || !this.wasChangedDate) {
      this.formData.get('scheduleService').setValue('1');
    } else {
      this.formData.get('startDateTime').setValue(this.startDateTime);
    }
  }

  /**
   * control flag to known when the date was seted
   * @return void
   */
  setted(): void {
    this.selectedDate = true;
    this.wasChangedDate = true;
    this.formData.get('scheduleService').setValue('2');
  }
}
